import type { RecursiveRequired, Settings } from '#/global'
import { cloneDeep } from 'es-toolkit'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'

const globalSettings: Settings.all = {
  app: {
    lightTheme: 'yuanyang-blue',
    darkTheme: 'yuanyang-blue',
    enablePermission: true,
  },
  menu: {
    mode: 'side',
    enableHotkeys: true,
  },
  toolbar: {
    navSearch: true,
    colorScheme: true,
  },
  topbar: {
    mode: 'fixed',
  },
  mainPage: {
    enableHotkeys: true,
  },
  navSearch: {
    enableHotkeys: true,
  },
  layout: {
    enableMobileAdaptation: true,
  },
  tabbar: {
    enable: true,
    style: 'fashion',
    enableHotkeys: true,
  },
  copyright: {
    enable: true,
    dates: '2025',
    company: '云奕智（深圳）信息科技有限公司',
    beian: ' 粤ICP备2025407320号-1',
    customer: ' 云奕智（深圳）信息科技有限公司',
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
